import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import { Company } from '../../store/company/types'
import { fetchRequest as getCompanyAction , selectCompany as selectCompanyAction, clearSelected as clearSelectedAction } from '../../store/company/actions'
import {getCompany} from '../../store/company/selectors';
import { Link } from 'react-router-dom';

// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
    loading: boolean
    data: Company[]
    errors?: string
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    fetchRequest: typeof getCompanyAction
    clearSelected: typeof clearSelectedAction
    selectCompany: typeof selectCompanyAction
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch


class CompanyIndexPage extends React.Component<AllProps> {
    public componentDidMount() {
        const { fetchRequest: fr, data:records } = this.props
        if(records.length === 0 )
        fr();
    }
    componentDidUpdate(prevProps:AllProps) {
                
      }
    private renderData() {
        const { loading, data } = this.props

        return (
            <div>
                {
                    loading && data.length === 0 && (
                        <span>Loading...</span>
                    )}
                {
                    //onClick={()=>this.props.selectCompany(hero.id)}
                    data.map(
                        hero => (
                            <li key={hero.id} >
                                <Link to={'/Company/Company/' + hero.id} >{hero.name}</Link>
                            </li>
                        )
                    )
                }
            </div>
        )
    }

    public render() {
        const { loading } = this.props

        const { fetchRequest } = this.props
        return (
            <div>
                <button type="button" onClick={()=>fetchRequest()} >Load</button>
                {
                    loading && (
                        <span>
                            Loading...
              </span>
                    )
                }
                <p>
                    <small>*in last 30 days</small>
                </p>
                {this.renderData()}
            </div>
        )
    }
}

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = (state: ApplicationState) => ({
    loading: state.company.ui.loading,
    errors: state.company.ui.errors,
    data: getCompany(state)
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
    fetchRequest:getCompanyAction,
    selectCompany:selectCompanyAction,
    clearSelected:clearSelectedAction,

}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CompanyIndexPage)
